import React from "react";
import { useHistory } from "react-router-dom";
import logo from "../logo.png";
import changelog from "../resources/changelog";
import { useState, useEffect, useRef } from "react";

const Changelog = () => {
  const history = useHistory();
  const cardRefs = useRef({});
  const LAST_SEEN_VERSION_KEY = 'vanex_last_seen_version';


  const getInitialVersion = () => {
    const hash = decodeURIComponent(window.location.hash.replace("#", ""));
    const match = changelog.find((release) => release.version === hash);
    return match ? match.version : changelog[0]?.version;
  };

  const [expandedVersions, setExpandedVersions] = useState({
    [getInitialVersion()]: true
  });

  const toggleVersion = (version) => {
    setExpandedVersions(prev => ({
      ...prev,
      [version]: !prev[version]
    }));
  };

  const handleVersionClick = (version) => {
    const isCurrentlyExpanded = expandedVersions[version];
    toggleVersion(version);

    if (!isCurrentlyExpanded) {
      history.replace({ hash: version });
    }
  };

  const expandAll = () => {
    const allExpanded = {};
    changelog.forEach((release) => {
      allExpanded[release.version] = true;
    });
    setExpandedVersions(allExpanded);
  };

  const collapseAll = () => {
    setExpandedVersions({});
  };

  const allAreExpanded = changelog.every(
    (release) => expandedVersions[release.version]
  );

  useEffect(() => {
    const hash = decodeURIComponent(window.location.hash.replace("#", ""));
    if (hash && cardRefs.current[hash]) {
      cardRefs.current[hash].scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    try {
      if (changelog.length > 0) {
        localStorage.setItem(
          LAST_SEEN_VERSION_KEY,
          changelog[0].version
        );
      }
    } catch (e) {
      // ignore write failures
    }
  }, []);
  
  return (
    <React.Fragment>
      <nav className="navbar navbar-expand navbar-dark sticky-top flex-md-nowrap p-0 no-shadow bg-dark-blue">
        <div className="container-fluid d-flex flex-row flex-grow-1">
          <span>
            <span
              onClick={() => history.push("/")}
              className="navbar-brand fw-semibold me-0 ps-1"
            >
              VaNe
              <img src={logo} className="vanex-navbar-logo" alt="logo" />
              <span className="project-view-version">
                v {process.env.REACT_APP_VERSION}
              </span>
            </span>

            <span className="navbar-brand fw-semibold me-0 ps-1">
              <i className="mx-2 fs-6 fas fa-chevron-right"></i>
              Release Notes
            </span>
          </span>
        </div>
      </nav>
      <div className="container mt-5 mb-5">
        <div className="d-flex justify-content-between align-items-center mb-2">
            <h2 className="mb-0">VaNex Release Notes</h2>

            <button
            className="btn btn-sm btn-outline-secondary"
            onClick={allAreExpanded ? collapseAll : expandAll}
            >
            {allAreExpanded ? "Collapse All" : "Expand All"}
            </button>
        </div>

        <p className="text-muted small mb-4">
            Tip: Use "Expand All" before searching release notes with Ctrl+F or Cmd+F.
        </p>

        {changelog.map((release, idx) => {
          const isExpanded = expandedVersions[release.version];
          const isLatest = idx === 0;

          return (
            <div
              key={release.version}
              id={release.version}
              ref={(el) => (cardRefs.current[release.version] = el)}
              className="card shadow-sm mb-4"
            >
              <div
                className="card-header bg-lighter-blue text-white d-flex justify-content-between align-items-center"
                style={{ cursor: "pointer" }}
                onClick={() => handleVersionClick(release.version)}
              >
                <div>
                  <strong>Version {release.version}</strong>
                  {isLatest && (
                    <span className="badge bg-success ms-2">Latest</span>
                  )}
                  <span className="ms-2">{release.date}</span>
                  {!isExpanded && release.summary && (
                    <div className="small text-white mt-1">
                      {release.summary}
                    </div>
                  )}
                </div>

                <i
                  className={`fas ${
                    isExpanded ? "fa-chevron-up" : "fa-chevron-down"
                  }`}
                />
              </div>

              {isExpanded && (
                <div className="card-body">
                  {release.sections.map((section, idx) => (
                    <div key={idx} className="mb-3">
                      <h5>{section.title}</h5>

                      <ul>
                        {section.items.map((item, itemIdx) => (
                          <li key={itemIdx}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default Changelog;